export default __webpack_public_path__ + "static/media/NamesNFT.1735c3aa.jpg";